import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import UsersLogsList from './UsersLogsList';
import { Breadcrumbs } from '../../../AbstractElements';


const BasicTables = () => {
    return (
        <Fragment>
            <Breadcrumbs title="Users" mainTitle='' />
            <Container fluid={true}>
                <Row>
                    <UsersLogsList />
                </Row>
            </Container>
        </Fragment>
    );
};

export default BasicTables;